import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { t } from "i18next";
import { IS_LOGGED_IN_USER } from "../../../assests/extention/commonfunction";
const path = "Assets/scss/header.module.scss";

export default function LoginHeader() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  return (
    <div className="container-fluid header">
      <div className="row header-row signin-row">
        <div className="  logo">
          <a
            onClick={() => {
              navigate(`/${lan}`);
            }}
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/logo.svg`}
              alt=""
            />
          </a>
        </div>
        {
          IS_LOGGED_IN_USER ? <></> :
            <div className="signin">
              {location.pathname == `/${lan}/signup` ? (
                <p>
                  {t("Already have an account?")} {' '}
                  <a
                    onClick={() => {
                      navigate(`/${lan}/loginwithemail`);
                    }}
                  >
                    {t("Login")}
                  </a>
                </p>
              ) : (
                <p>
                  {t("Don’t have an account?")} {' '}
                  <a
                    onClick={() => {
                      navigate(`/${lan}/signup`);
                    }}
                  >
                    {t("Sign Up")}
                  </a>
                </p>
              )}
            </div>
        }
      </div>
    </div>
  );
}
